import {useNavigate} from 'react-router-dom';
import {Button, Modal, Typography, Row, Col} from 'antd';
import {
    CarOutlined, DeleteOutlined, CalendarOutlined, BorderlessTableOutlined, EnvironmentOutlined
} from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import {formatAddress, getSessionData} from "../../utility/global-util";
import DataCards from "../../components/data/DataCards";
import {getDriverRouteById} from "../../components/routes/driverRoutes";
import { iconLocations } from "../../components/image/IconLocations";
import ExpandableText from '../../components/data/ExpandableText';
import {removeMessage, markMessageAsRead} from "../../api/message";
import {getBooking, getWorkRequest} from "../../api/maintenance";
import {useState} from "react";
import useOnlineStatus from "../../utility/hooks/useOnlineStatus";

const { Text} = Typography;

const Notifications = ({ notifyModalVisible, setNotifyModalVisible, notifications, vehicleChange, refreshNotifications }) => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { isOnline } = useOnlineStatus();

    const [selectedNotification, setSelectedNotification] = useState(null);
    const [notificationData, setNotificationData] = useState(null);

    const adjustedHeader = (headerText) => {
        const bracketStart = headerText.indexOf('(');
        const bracketEnd = headerText.indexOf(')');
        const start = headerText.substring(0, bracketStart);
        const date  = headerText.substring(bracketStart, bracketEnd + 1);
        const end = headerText.substring(bracketEnd + 1);
        return <span>{start}<span style={{ textWrap: 'nowrap'}}>{date}</span>{end}</span>;
    };

    // Card Parts
    const header = (notification) => {
        return adjustedHeader(notification.header);
    };
    const detail = (notification) => {
        function getIcon(status)
        {
            if(status === 'UNREAD')
            {
                return (<img src={iconLocations.ENVELOPE_ICON} style={{height:"1em"}} alt="" />);
            }
            else
            {
                return (<img src={iconLocations.ENVELOPE_OPEN_ICON} style={{height:"1em"}} alt="" />);
            }
        }

        function getFontWeight(status)
        {
            if(status === 'UNREAD')
            {
                return 'bold';
            }
            else
            {
                return 'normal';
            }
        }

        return (
            <Text style={{fontWeight : getFontWeight(notification.status)}}>
                <Row align="middle">
                    <table>
                        <tbody>
                            <tr>
                                <td>{getIcon(notification.status)}</td>
                                <td >{notification.message ? notification.message : ''}</td>
                            </tr>
                        </tbody>
                    </table>
                </Row>
            </Text>);
    };

    function changeContract(notification)
    {
        // Change vehicle if needed
        const currentContract = getSessionData('currentContract');
        if (vehicleChange && currentContract && currentContract.contractNo && notification && notification.contract && currentContract.contractNo !== notification.contract.contractNo) {
            console.log('..notification changing vehicle using contract ' + notification.contract.contractNo);
            vehicleChange(notification.contract);
        }
    }

    // Card action (chevron right)
    const actionItem  = (notification) => {

        // Redirect according to type
        if (notification.type === 'MOT_EXPIRY') {
            changeContract(notification);
            navigate(getDriverRouteById('home') + '?action=MOT');
            setNotifyModalVisible(false);
        }
        else if (notification.type === 'LICENSE_EXPIRY') {
            changeContract(notification);
            navigate(getDriverRouteById('vehicle-details') + '?action=LIC');
            setNotifyModalVisible(false);
        }
        else if (notification.type === 'DEFECTS_NO_ACTION') {
            changeContract(notification);
            navigate(getDriverRouteById('vehicle-details') + '?action=DNA');
            setNotifyModalVisible(false);
        }
        else if (notification.type === 'DEFECTS_BOOKED') {
            changeContract(notification);
            navigate(getDriverRouteById('vehicle-details') + '?action=DNA');
            setNotifyModalVisible(false);
        }
        else if (notification.type === 'INSPECTION_REMINDER') {
            changeContract(notification);
            navigate(getDriverRouteById('walkaround'));
            setNotifyModalVisible(false);
        }
        else {
            if(notification.type === 'BOOKING_REQUEST_DECLINED') {
                getWorkRequest(notification.data.WorkRequestId).then(res => setNotificationData(res));
            }    
            else if(notification.type === 'BOOKING_REQUEST_ACCEPTED') {
                getBooking(notification.data.BookingId).then(res => setNotificationData(res));
            }
            setSelectedNotification(notification);
        }

        // Mark as read if online
        if (isOnline) {
            markMessageAsRead(notification.key).then(() => {
                refreshNotifications();
            })
        }
    };
    // Card action (chevron right)
    const deleteItem  = (index) => {
        removeMessage(notifications[index].key).then(() => {
            refreshNotifications();
        })
    };

    const NotificationDetail = () => {
        if(notificationData)
        {
            if(selectedNotification.type === 'BOOKING_REQUEST_DECLINED') {
                return <Row>
                          <Col span={24}><Text>{t('message.work_request_declined', {'0' : selectedNotification.contract.contractVehicle.regNo})}</Text></Col>
                          <Col span={24}><Text>{notificationData.reason}</Text></Col>
                       </Row>
            }
            else if(selectedNotification.type === 'BOOKING_REQUEST_ACCEPTED') {
                return <> 
                <Row style={{width:"100%"}}>
                  <Col span={24}>
                      <Text style={{ marginLeft: '5px' }}>{t(notificationData.status === 'CONFIRMED' ? 'message.booking_confirmed' : 'message.booking_provisional')}</Text>
                  </Col>
                  <Col span={24}>
                      <CarOutlined /><Text style={{ marginLeft: '5px' }}>{selectedNotification.contract.contractVehicle.regNo}</Text>
                  </Col>
                  <Col span={24}>
                      <BorderlessTableOutlined /><Text style={{ marginLeft: '5px' }}>{notificationData.reference}</Text>
                  </Col>
                  <Col span={24}>
                      <CalendarOutlined /><Text style={{ marginLeft: '5px' }}>{notificationData.bookingDate}</Text>
                  </Col>
                  <Col span={24}>
                      <EnvironmentOutlined /><Text style={{ marginLeft: '5px' }}>{notificationData.supplierName?notificationData.supplierName:t("value.tbc")}</Text>
                  </Col>
              </Row>
              <Row>
                 <Col span={24}>
                 {
                      notificationData.supplierAddress
                      ?
                         <Row><ExpandableText text={formatAddress(notificationData.supplierAddress)}/></Row>
                      :
                      <></>
                 }
                 </Col>           
              </Row>
              </>
            }
        }
        return <></>
    }

    return (
        <>
          <Modal className="std-portal-popup"
               title={t('title.notifications')}
               open={notifyModalVisible}
               closable={true}
               maskClosable={false}
               onCancel={() => setNotifyModalVisible(false)}
               keyboard={false}
               footer={[
                   <Button key={1} type="primary" onClick={() => setNotifyModalVisible(false)}>
                       {t('action.close')}
                   </Button>,
               ]}
          >
            <DataCards items={notifications} actionItem={actionItem} deleteItem={deleteItem} deleteIcon={<DeleteOutlined />} header={header} wrapHeaders={true} detail={detail} overrideNoDataMessage={t('message.no_notifications')} />
          </Modal>
          <Modal className="std-portal-popup"
               title={selectedNotification ? adjustedHeader(selectedNotification.header) : ""}
               open={selectedNotification}
               closable={true}
               maskClosable={false}
               onCancel={() => setSelectedNotification(null)}
               keyboard={false}
               footer={<></>}
          >
            <NotificationDetail/>
          </Modal>
        </>
    )
}

export default Notifications;